import { render, staticRenderFns } from "./OrderExpressTrack.vue?vue&type=template&id=3c288a82&"
import script from "./OrderExpressTrack.vue?vue&type=script&lang=js&"
export * from "./OrderExpressTrack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports